import { ALABASTER_WHITE, GREY_CHATEAU } from "../../../constants/colors";

const backgroundColor = ALABASTER_WHITE;
const borderColor = GREY_CHATEAU;

export const fallbackValues = {
  backgroundColor,
  borderColor
};
